export const parseStringBoolean = boolString => {
  if ((boolString == null ? void 0 : boolString.toLowerCase()) === 'true') {
    return true;
  }
  if ((boolString == null ? void 0 : boolString.toLowerCase()) === 'false') {
    return false;
  }
};
export function createPubSub() {
  let eventMap = {};
  return {
    emit: function (event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (eventMap[event] ?? []).forEach(cb => cb(...args));
    },
    on: (event, callback) => {
      if (!eventMap[event]) {
        eventMap[event] = new Set();
      }
      eventMap[event].add(callback);
    },
    off: (event, callback) => {
      if (!eventMap[event]) {
        return;
      }
      eventMap[event].delete(callback);
    },
    clear: () => {
      eventMap = {};
    }
  };
}
//# sourceMappingURL=index.js.map